
<error-error-content 
  image="assets/img/images/error-images/image1.png"
  errorType="BAD_REQUEST"
  copy="ERROR_400"></error-error-content>

